import script from "./Table_.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_.vue?vue&type=script&setup=true&lang=js"

import "./Table_.vue?vue&type=style&index=0&id=55d8ece0&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d8ece0"]])

export default __exports__